export default __webpack_public_path__ + "static/media/testimonial-6-3.d35bef0d.jpg";